import React, { useReducer, useEffect, useState } from 'react'
import './theme/index.css'
import { Router } from 'react-router-dom'
import SweetAlert from 'react-sweetalert2'
import './App.css'
import { Box, CircularProgress } from '@material-ui/core'
import Routes from './routes'
import UserService from './services/UserService'
import history from './services/history'
import { examineeActiveAssessments, userInfo } from './api/calls'
import SnackbarContextProvider from './components/SnackbarContext'
import 'intro.js/introjs.css'

import {
  questionMiddleware,
  questionReducer,
  questionActions,
  initialState as questionInitialState,
} from './store/question'

import { Context } from './store/context'
import Hotjar from './helpers/Hotjar'

function App() {
  const { Provider } = Context
  const [loadingUser, setLoadingUser] = useState(true)
  const [currentUser, setCurrentUser] = useState(undefined)
  const [questionState = questionInitialState, questionDispatch] = useReducer(questionReducer)
  const [questActions, setQuestActions] = useState({})
  const [errorExaminee, setErrorExaminee] = useState(false)

  useEffect(() => {
    const find = async () => {
      try {
        const { data } = await userInfo(UserService.getUserId())
        const assessmentData = await examineeActiveAssessments(data.id)
        setCurrentUser({ ...data, assessmentInfo: assessmentData.data })
        localStorage.setItem(
          'user_info',
          JSON.stringify({ ...data, assessmentInfo: assessmentData.data }),
        )
        localStorage.setItem('codExaminee', data.codExaminee)
        localStorage.setItem('codAssessment', data.codAssessment)
      } catch (error) {
        if (error.response.status === 404) {
          setErrorExaminee(true)
        }
      } finally {
        setLoadingUser(false)
      }
    }
    find()
  }, [])

  useEffect(() => {
    const enhancedQuestionDispatch = questionMiddleware(questionDispatch)
    setQuestActions(questionActions(enhancedQuestionDispatch))
  }, [])

  const handleAction = () => {
    UserService.forceLogout()
  }

  if (loadingUser) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
        <CircularProgress size="10rem" />
      </Box>
    )
  }

  return (
    <Provider
      value={{
        question: {
          actions: questActions,
          state: questionState,
        },
        user: {
          state: currentUser,
        },
        currentUser,
      }}
    >
      <SweetAlert
        show={errorExaminee || questionState.error.status}
        title={
          questionState.error.status
            ? questionState.error.message
            : 'Estudante não encontrado, entre em contato com o administrador'
        }
        confirmButtonText="Ok"
        onConfirm={() => handleAction()}
      />
      <SnackbarContextProvider>
        <Hotjar />
        <Router history={history}>
          <Routes />
        </Router>
      </SnackbarContextProvider>
    </Provider>
  )
}

export default App
